import { useEffect } from "react"

import { NEW_PROJECT_COLOR } from "shared/types/Project"

interface UseProjectColorArgs {
  element: HTMLElement | null
  color: string | null | undefined
  hoverColor?: string | null | undefined
}

export function useProjectColor({
  element,
  color,
  hoverColor
}: UseProjectColorArgs) {
  useEffect(() => {
    if (color) {
      element?.style.setProperty("--project-color", color || NEW_PROJECT_COLOR)
    }
    if (hoverColor) {
      element?.style.setProperty(
        "--project-hover-color",
        hoverColor || NEW_PROJECT_COLOR
      )
    }
  }, [element, color, hoverColor])
}
